import { getCdnUrl } from '~/domains/assets/utils/getCdnUrl';

const getSafeLeagueAlias = (leagueAlias: string): string =>
  [
    //
    'nfl',
    'nba',
    'pga',
    'nhl',
    'ncaab',
    'mlb',
  ].find((alias) => leagueAlias.startsWith(alias)) || leagueAlias;

export const SUPPORTED_LEAGUE_TEAM_IMAGES = new Set(['nfl', 'ncaaf', 'ncaab']);

/** Resolve a team/player image URL, preferring a BE-supplied `iconUrl` over the client-side CDN compose. */
export const getTeamOrPlayerImageUrl = (
  leagueAlias: string,
  teamOrPlayerId?: string,
  iconUrl?: string
): string =>
  getCdnUrl(iconUrl || `/${getSafeLeagueAlias(leagueAlias)}/${teamOrPlayerId ?? 'default'}.png`);
